/**
 * Panneau de marque de l'écran de connexion.
 *
 * Il annonçait « 142 commandes par jour, 40 fournisseurs, 18 482 clients »,
 * « 99,87 % d'uptime » et « 22 collaborateurs » : aucun de ces chiffres n'a
 * jamais été mesuré, et la boutique n'avait pas encore ouvert. Une équipe qui
 * lit chaque matin des chiffres inventés finit par ne plus croire aucun chiffre
 * de l'outil — y compris les vrais.
 *
 * Ce qui reste est vérifiable : trois hubs réellement ouverts, la comptabilité
 * tenue au référentiel OHADA, et le rappel que la session est journalisée.
 */
export function AuthBrand() {
	return (
		<aside className="auth-aside">
			<div className="auth-brand">
				<img
					src="/logos/Logo-texte-blanc.svg"
					alt="Akwaba"
					style={{ height: 40, width: "auto" }}
				/>
				<div className="auth-brand-tag">Admin</div>
			</div>

			<div className="auth-pitch">
				<div className="eyebrow">Centre nerveux des opérations</div>
				<h1>
					Le <em>back-office</em> qui tient le catalogue, les commandes et les
					tournées — d'un seul endroit.
				</h1>
				<p>
					Accès réservé aux collaborateurs d'Akwaba Commerce SA. Chaque session
					est journalisée, et les opérations sensibles demandent la validation
					d'un second responsable.
				</p>

				<div className="auth-mini-stats">
					{/* Trois libellés de longueur comparable : la version précédente
					    alignait « Hubs · Yaoundé, Douala, Bafoussam » sur deux lignes
					    à côté de « Régions livrées » sur une, et la rangée penchait. */}
					<div className="auth-mini-stat">
						<div className="v">3</div>
						<div className="l">Hubs logistiques</div>
					</div>
					<div className="auth-mini-stat">
						<div className="v">10</div>
						<div className="l">Régions livrées</div>
					</div>
					<div className="auth-mini-stat">
						<div className="v">OHADA</div>
						<div className="l">Comptabilité</div>
					</div>
				</div>
			</div>

			<div className="auth-meta">
				<span>Yaoundé, Cameroun</span>
			</div>
		</aside>
	);
}
